import { render, staticRenderFns } from "./form-preview.vue?vue&type=template&id=8c507f20&scoped=true&"
import script from "./form-preview.vue?vue&type=script&lang=js&"
export * from "./form-preview.vue?vue&type=script&lang=js&"
import style0 from "./form-preview.vue?vue&type=style&index=0&id=8c507f20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c507f20",
  null
  
)

component.options.__file = "form-preview.vue"
export default component.exports